package com.dotpx.ambient

internal class MutableVisualSignal(
    var sound: AmbienceVisualSound = AmbienceVisualSound.Room,
    var weight: Float = 0f,
    var convergence: Float = 0f,
    var energy: Float = 0f,
) {
    fun clear() {
        sound = AmbienceVisualSound.Room
        weight = 0f
        convergence = 0f
        energy = 0f
    }
}
